import { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./UnavailableProductHeader.scss";
import classnamesBind from "classnames/bind";

const classnames = classnamesBind.bind(styles);

export default function UnavailableProductHeader({ title, message }) {
  const { isMobile } = useRuntimeConstants();

  useLayoutEffect(() => {
    const loader = document.getElementById("unavailable-skeleton-header");

    if (loader) {
      loader.parentElement.removeChild(loader);
    }
  }, []);

  return (
    <header className={styles.header}>
      <div>
        <h2
          className={classnames(styles.title, {
            [styles.smallViewport]: isMobile,
          })}
        >
          {title}
        </h2>
        <p
          className={classnames(styles.message, {
            [styles.smallViewport]: isMobile,
          })}
        >
          {message}
        </p>
      </div>
    </header>
  );
}

UnavailableProductHeader.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
